// Source: https://github.com/vinted/dwh-schema-registry/blob/5387d2ce7b44ee93711a15dfb97c60a4d984f22c/avro/events/common/shared/user.avdl#L25
type UserTarget = 'save_address' | 'submit'

type ConfirmWalletSource = 'settings' | 'transaction' | 'restricted'

type ConfirmWalletEventArgs = {
  source: ConfirmWalletSource
  prefilled_billing_address?: boolean | null
}

type ConfirmWalletEventExtra = {
  source: ConfirmWalletSource
  prefilled_billing_address?: boolean | null
}

export const confirmWalletEvent = (args: ConfirmWalletEventArgs) => {
  const extra: ConfirmWalletEventExtra = {
    source: args.source,
  }

  return {
    event: 'user.confirm_wallet',
    extra,
  }
}

type ClickEventArgs = {
  target: UserTarget
  screen?: string | null
  targetDetails?: string | null
  path?: string | null
  env?: string | null
}

type ClickEventExtra = {
  target: UserTarget
  screen?: string
  target_details?: string
  path?: string | null
  env?: string | null
}

export const clickEvent = (args: ClickEventArgs) => {
  const { target, screen, targetDetails, env, path } = args
  const extra: ClickEventExtra = { target }

  if (screen) extra.screen = screen

  if (targetDetails) extra.target_details = targetDetails

  if (env) extra.env = env

  if (path) extra.path = path

  return {
    event: 'user.click',
    extra,
  }
}

type ViewScreenEventArgs = {
  screen: string
}

export const viewScreenEvent = (args: ViewScreenEventArgs) => {
  const { screen } = args

  const extra = {
    screen,
  }

  return {
    event: 'user.view_screen',
    extra,
  }
}
